var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifyFactor7X(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18 34C26.8366 34 34 26.8366 34 18C34 9.16344 26.8366 2 18 2C9.16344 2 2 9.16344 2 18C2 26.8366 9.16344 34 18 34Z",
    fill: "#37F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 35C27.3888 35 35 27.3888 35 18C35 8.61116 27.3888 1 18 1C8.61116 1 1 8.61116 1 18C1 27.3888 8.61116 35 18 35Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0627 12.8596L23.3691 11.5821L19.4828 3.61624C19.3766 3.39814 19.202 3.22158 18.9863 3.11426C18.4453 2.84423 17.7879 3.06925 17.5174 3.61624L13.6311 11.5821L4.9374 12.8596C4.6978 12.8942 4.4786 13.0085 4.3108 13.1816C4.108 13.3923 3.9962 13.6759 4.0001 13.97C4.0039 14.264 4.1231 14.5445 4.3314 14.7498L10.6214 20.9501L9.1353 29.7054C9.1005 29.909 9.1228 30.1185 9.1997 30.31C9.2766 30.5015 9.405 30.6674 9.5704 30.7889C9.7358 30.9103 9.9316 30.9825 10.1355 30.9972C10.3394 31.0119 10.5433 30.9685 10.7241 30.872L18.5001 26.7385L26.2761 30.872C26.4884 30.9863 26.7349 31.0244 26.9711 30.9828C27.5669 30.879 27.9675 30.3077 27.8648 29.7054L26.3788 20.9501L32.6687 14.7498C32.8399 14.5802 32.9529 14.3586 32.9872 14.1163C33.0796 13.5104 32.6619 12.9496 32.0627 12.8596Z",
    fill: "#9BF9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0234 14.5469L13.4219 17.1172L14.8594 14.5469H17.2578L14.8672 18.6797L17.3672 23H14.9609L13.4375 20.2813L11.9141 23H9.5078L12.0078 18.6797L9.6172 14.5469H12.0234ZM25.9844 11.625V12.8359L21.5859 23H19.2109L23.6094 13.3828H17.9453V11.625H25.9844Z",
    fill: "#00555A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyFactor7X);
export default __webpack_public_path__ + "static/media/verify_factor7x.8f7bf3bdfeaf3fa3b819e03167fc08a1.svg";
export { ForwardRef as ReactComponent };